module.exports = __webpack_public_path__ + "img/horizontal_3_5_6000.c7dc88da.png";